import React from 'react';
import { useTranslation } from 'react-i18next';
const ShowSimilarProductInline = (props) => {
    const { t } = useTranslation();
    return (React.createElement("div", { className: "similar-product-description" },
        React.createElement("span", null,
            t('product.sizenotavailable'),
            " "),
        React.createElement("button", { className: "similar-product-btn text-uppercase", disabled: !props.enabled, onClick: () => props.setSimilarModalOpen() }, t('similarproduct.button'))));
};
export default ShowSimilarProductInline;
